import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/Home'
import Keyword from '@/view/Keyword'
import Periodical from '@/view/Periodical'
import Detail from '@/view/detail/Detail'
import OrgHome from '@/view/organization/OrgHome'
import Overview from '@/view/organization/Overview'
import RetrieveName from '@/view/RetrieveName'
import RetrieveField from '@/view/RetrieveField'
import RetrieveInst from '@/view/RetrieveInst'
import Login from '@/view/Login'
import road from '@/view/road/road'
import Loading from '@/components/common/Loading'
import basic from '@/view/claim/basic'
import research from '@/view/claim/research'
import claimSearch from '@/view/claim/claimSearch'
import claimResearch from '@/view/claim/claimResearch'
import manage from '@/view/claim/manage'
import center from '@/view/center/center'
import Maintenance from '@/view/maintenance'
import registered from '@/view/registered/registered'
import blog1 from '@/view/blog/blog1'
import blog2 from '@/view/blog/blog2'
import thinkTank from '@/view/blog/thinkTank'
import Ai from '@/view/blog/Ai'
import contrast from '@/view/Contrast'
import Us from '@/view/Us/Us'
import help from '@/components/common/help'
import mHome from '@/mobile/Home'
import mSearch from '@/mobile/Search'
import mDetail from '@/mobile/Detail'
import RetrieveFieldNew from '@/view/RetrieveFieldNew'
import state from '@/view/state/state'

import newsearch from '@/view/newsearch/newsearch'

import mUs from '@/mobile/Us'
import test from '@/view/test'
Vue.use(Router)
export default new Router({
  // base: 'expert',
  mode: 'history',
  // eslint-disable-next-line no-sparse-arrays
  routes: [
    {
      path: '*',
      name: 'Maintenance',
      component: Maintenance
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/LoginForClient',
      name: 'Login',
      component: Login
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Keyword',
      name: 'Keyword',
      component: Keyword
    },
    {
      path: '/Periodical',
      name: 'Periodical',
      component: Periodical
    },
    {
      path: '/Detail',
      name: 'Detail',
      component: Detail,
      meta: {requiresAuth: true}
    },
    {
      path: '/RetrieveFieldNew',
      name: 'RetrieveFieldNew',
      component: RetrieveFieldNew,
      meta: {requiresAuth: true}
    },
    {
      path: '/newsearch',
      name: 'newsearch',
      component: newsearch
    },
    {
      path: '/OrgHome',
      name: 'OrgHome',
      component: OrgHome,
      meta: {requiresAuth: true}
    },
    {
      path: '/Overview',
      name: 'Overview',
      component: Overview,
      meta: {requiresAuth: true}
    },
    {
      path: '/RetrieveName',
      name: 'RetrieveName',
      component: RetrieveName,
      meta: {requiresAuth: true}
    },
    {
      path: '/RetrieveInst',
      name: 'RetrieveInst',
      component: RetrieveInst,
      meta: {requiresAuth: true}
    },
    {
      path: '/RetrieveField',
      name: 'RetrieveField',
      component: RetrieveField,
      meta: {requiresAuth: true}
    },
    {
      path: '/Loading',
      name: 'Loading',
      component: Loading,
      meta: {requiresAuth: true}
    },
    {
      path: '/road',
      name: 'road',
      component: road
    },
    {
      path: '/claim/basic',
      name: 'basic',
      component: basic,
      meta: {requiresAuth: true}
    },
    {
      path: '/claim/research',
      name: 'research',
      component: research,
      meta: {requiresAuth: true}
    },
    {
      path: '/claim/manage',
      name: 'manage',
      component: manage,
      meta: {requiresAuth: true}
    },
    {
      path: '/claim/claimSearch',
      name: 'claimSearch',
      component: claimSearch,
      meta: {requiresAuth: true}
    },
    {
      path: '/claim/claimResearch',
      name: 'claimResearch',
      component: claimResearch,
      meta: {requiresAuth: true}
    },
    {
      path: '/center',
      name: 'center',
      component: center,
      meta: {requiresAuth: true}
    },
    {
      path: '/blog1',
      name: 'blog1',
      component: blog1,
      meta: {requiresAuth: true}
    },
    {
      path: '/blog2',
      name: 'blog2',
      component: blog2,
      meta: {requiresAuth: true}
    },
    {
      path: '/thinkTank',
      name: 'thinkTank',
      component: thinkTank,
      meta: {requiresAuth: true}
    },
    {
      path: '/Ai',
      name: 'Ai',
      component: Ai,
      meta: {requiresAuth: true}
    },
    {
      path: '/registered',
      name: 'registered',
      component: registered
    },
    {
      path: '/contrast',
      name: 'contrast',
      component: contrast
    },
    {
      path: '/help',
      name: 'help',
      component: help,
      meta: {requiresAuth: true}
    },
    {
      path: '/Us',
      name: 'Us',
      component: Us,
      meta: {requiresAuth: true}
    },
    {
      path: '/Mobile/Home',
      name: 'mHome',
      component: mHome,
      meta: {requiresAuth: true}
    },
    {
      path: '/Mobile/Search',
      name: 'mSearch',
      component: mSearch
    }, {
      path: '/Mobile/Detail',
      name: 'mDetail',
      component: mDetail
    }, {
      path: '/Mobile/Us',
      name: 'mUs',
      component: mUs
    },, {
      path: '/state',
      name: 'state',
      component: state,
      meta: {requiresAuth: true}
    }, {
      path: '/test',
      name: 'test',
      component: test
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js